import { useDispatch, useSelector } from "react-redux";
import "./PaymentB2CDetails.scss";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import _ from "lodash";
import BreadCrumbComponent from "../Misc/BreadCrumb/BreadCrumbComponent";
import moment from "moment";
import { membershipPaymentDetailClear, productPaymentDetailClear, providerPaymentDetailClear } from "../../../redux/checkout/actions";
import RightPanelPaymentSection from "./RightPanelPayment/RightPanelPaymentSection";
import useLogin from "../../../custom-hooks/useLogin";
import { routeList } from "../../../utils/routeList";
import { signUpApiReq } from "../../../redux/auth/actions";
import { encyptData, formatCartProductData, isMainDomain } from "../../../utils/AppUtils";
import FormButtonComponent from "../FormControl/FormButton/FormButtonComponent";
import { RightArrowIcon } from "../../../utils/SvgComps";
import { myCart } from "../../../redux/Cart/actions";
import { isAndroid, isIOS } from "react-device-detect";

const PaymentB2CDetails = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLoggedIn, userData } = useLogin()

  const search = window.location.search;
  const params = new URLSearchParams(search);
  const type = params.get("type");
  const isMobile = params.get("isMobile");

  const [breadCrumbData, setBreadCrumbData] = useState([
    { name: 'Cart', active: false, link: "", isLoading: true },
    { name: 'Payment', active: false, link: "", isLoading: true },
    { name: 'Summary', active: false, link: "", isLoading: true },
  ])
  const [billingData, setBillingData] = useState({
    email: "", brokerageName: "", brokerageEmail: "",
    firstName: "", lastName: "",
    phoneNumber: "", addressLine1: "", addressLine2: "",
    city: "", state: "", country: "", postalCode: ""
  })
  const [isCouponApplied, setIsCouponApplied] = useState(false)
  const [membershipCardInfo, setMembershipCardInfo] = useState({
    isLoading: true,
    id: "",
    title: "",
    logoAltText: "",
    logoURL: "",
    bannerURL: "",
    tagsArray: [],
    price: "",
    priceText: ""
  })
  const [providerCardInfo, setProviderCardInfo] = useState({
    isLoading: true,
    id: "",
    code: "",
    title: "",
    logoAltText: "",
    logoURL: "",
    bannerURL: "",
    tagsArray: [],
    price: "",
    isRecurring: false
  })
  const [paymentDetail, setPaymentDetails] = useState({
    cardType: "", cardEnding: "", orderId: "",
    transactionId: "", purchaseDate: "", zeroOrder: false
  })
  const [paymentIntentInfo, setPaymentIntentInfo] = useState({
    isLoading: false, taxes: "", total: "", discount: "", zeroOrder: false
  })
  const [productCardInfo, setProductCardInfo] = useState([])

  const membershipPaymentDetail = useSelector(state => state.checkout.membershipPaymentDetail)
  const productPaymentDetail = useSelector(state => state.checkout.productPaymentDetail)
  const providerPaymentDetail = useSelector(state => state.checkout.providerPaymentDetail)

  useEffect(() => {
    return (() => {
      dispatch(membershipPaymentDetailClear())
      dispatch(productPaymentDetailClear())
      dispatch(providerPaymentDetailClear())
    })
  }, [dispatch])

  useEffect(() => {
    if (!_.isEmpty(membershipPaymentDetail)) {
      console.log(membershipPaymentDetail)
      const billingInfo = membershipPaymentDetail.billing_data
      const productInfo = membershipPaymentDetail.product_info
      const paymentDetails = membershipPaymentDetail.payment_details
      const providerData = membershipPaymentDetail.provider_data
      if (!_.isEmpty(billingInfo)) {
        setBillingData({
          email: billingInfo.contactEmail,
          brokerageName: billingInfo.brokerageName ? billingInfo.brokerageName : "",
          brokerageEmail: billingInfo.brokerageEmail ? billingInfo.brokerageEmail : "",
          firstName: billingInfo.firstName,
          lastName: billingInfo.lastName,
          phoneNumber: billingInfo.phoneNumber,
          addressLine1: billingInfo.addressLine1,
          addressLine2: billingInfo.addressLine2,
          city: billingInfo.city,
          state: billingInfo.state,
          country: billingInfo.country,
          postalCode: billingInfo.postalCode
        })

        if (!isLoggedIn) {

          const payload = {
            full_name: `${billingInfo.firstName} ${billingInfo.lastName}`,
            email: billingInfo.contactEmail,
            broker_email: billingInfo.brokerageEmail ? billingInfo.brokerageEmail : "",
            user_subscription_id: productInfo.id,
            stripe_subscription_id: paymentDetails.subscription_id,
            action: "redirect-setpassword",
          }
          // dispatch(
          //   signUpApiReq({
          //       module: "signUpReq",
          //       postData: {
          //           data: encyptData(payload)
          //       }
          //   })
          // );
        }
      }
      if (!_.isEmpty(productInfo)) {
        let tagsArray = [];
        let logoURL = ""
        let logoAltText = ""
        if (providerData) {
          tagsArray.push(`Xsel ${productInfo.title} subscription`)
          logoURL = providerData.provider_img;
          logoAltText = ""
        }
        setMembershipCardInfo({
          isLoading: false,
          id: productInfo.id,
          title: `Xsel ${productInfo.title} subscription plan - Renews 
                    ${productInfo.billing_type === 'annually' ? 'yearly' : 'monthly'}`,
          price: _.toNumber(productInfo.selling_price).toFixed(2),
          priceText: `$${_.toNumber(productInfo.selling_price).toFixed(2)}${productInfo.billing_type === 'annually' ? '/month' : ''}, billed ${productInfo.billing_type}`,
          bannerURL: productInfo.subscription_img,
          logoURL,
          logoAltText,
          tagsArray
        })
      }
      if (!_.isEmpty(paymentDetails)) {
        setPaymentDetails({
          cardType: paymentDetails.card_brand,
          cardEnding: paymentDetails.card_last4,
          orderId: 'XSEL-' + paymentDetails.order_number,
          transactionId: paymentDetails.stripe_invoice_number,
          purchaseDate: moment.unix(paymentDetails.purchased_on).tz('America/New_York').format('MMM DD, YYYY'),
          zeroOrder: false
        })
        setPaymentIntentInfo({
          isLoading: false,
          taxes: paymentDetails.taxes,
          total: paymentDetails.total,
          discount: 0,
          zeroOrder: false
        })
        setIsCouponApplied(false)
      }
      setBreadCrumbData([
        { name: 'Subscription', active: false, link: isMobile === 'true' ? "" :routeList.SUBSCRIPTION_PAGE, isLoading: false },
        { name: 'Payment', active: false, link: isMobile === 'true' ? "" :"/subscription-payments", isLoading: false },
        { name: 'Summary', active: true, link: "", isLoading: false },
      ])
    } else {
      // if (type === 'subscription') {
      //   navigate('/subscription')
      // } else {
      //   navigate('/cart')
      // }
    }
  }, [membershipPaymentDetail])

  useEffect(() => {
    console.log(productPaymentDetail)
    if (!_.isEmpty(productPaymentDetail)) {
      const billingInfo = productPaymentDetail.billing_data
      const cartList = productPaymentDetail.cart_list
      const paymentDetails = productPaymentDetail.payment_details
      if (!_.isEmpty(billingInfo)) {
        setBillingData({
          email: billingInfo.email,
          brokerageName: billingInfo.brokerageName ? billingInfo.brokerageName : "",
          brokerageEmail: billingInfo.brokerageEmail ? billingInfo.brokerageEmail : "",
          firstName: billingInfo.name,
          lastName: '', //billingInfo.lastName,
          phoneNumber: billingInfo.phone,
          addressLine1: billingInfo.address.line1,
          addressLine2: billingInfo.address.line2,
          city: billingInfo.address.city,
          state: billingInfo.address.state,
          country: billingInfo.address.country,
          postalCode: billingInfo.address.postal_code
        })

        if (!isLoggedIn) {

          // const payload = {
          //   full_name: `${billingInfo.firstName} ${billingInfo.lastName}`,
          //   email: billingInfo.contactEmail,
          //   broker_email: billingInfo.brokerageEmail ? billingInfo.brokerageEmail : "",
          //   user_subscription_id: productInfo.id,
          //   stripe_subscription_id: paymentDetails.subscription_id,
          //   action: "redirect-setpassword",
          // }
          // dispatch(
          //   signUpApiReq({
          //       module: "signUpReq",
          //       postData: {
          //           data: encyptData(payload)
          //       }
          //   })
          // );
        }
      }
      if (!_.isEmpty(cartList)) {
        setProductCardInfo(_.map(cartList, (cartData) => {
          cartData.isMobile = isMobile;
          return formatCartProductData(cartData)
      }))
      }
      if (!_.isEmpty(paymentDetails)) {
        setPaymentDetails({
          cardType: paymentDetails.card_brand,
          cardEnding: paymentDetails.card_last4,
          orderId: 'XSEL-' + paymentDetails.order_number,
          transactionId: "",
          purchaseDate: moment.unix(paymentDetails.purchased_on).tz('America/New_York').format('MMM DD, YYYY'),
          zeroOrder: paymentDetails.zero_order
        })
        setPaymentIntentInfo({
          isLoading: false,
          discount: paymentDetails.discount,
          taxes: paymentDetails.tax_total,
          total: paymentDetails.total,
          zeroOrder: paymentDetails.zero_order
        })
        setIsCouponApplied(paymentDetails.discount > 0 ? true : false)
      }
      setBreadCrumbData([
        { name: 'Home', active: false, link: isMobile === 'true' ? "" :routeList.HOME_PAGE, isLoading: false },
        { name: 'Cart', active: false, link: isMobile === 'true' ? "" : routeList.CART_PAGE, isLoading: false },
        { name: 'Payment', active: false, link: isMobile === 'true' ? "" : routeList.CART_PAGE, isLoading: false },
        { name: 'Summary', active: true, link: "", isLoading: false },
      ])
      dispatch(myCart({module: "myCart"}))
    } else {
      // if (type === 'subscription') {
      //   navigate('/subscription')
      // } else {
      //   navigate('/cart')
      // }
    }
  }, [productPaymentDetail])


  useEffect(() => {
    if (!_.isEmpty(providerPaymentDetail)) {
      console.log('PROVIDER PAYMENT DETAIL')
      console.log(providerPaymentDetail)
      const billingInfo = providerPaymentDetail.billing_data
      const productInfo = providerPaymentDetail.product_info
      const paymentDetails = providerPaymentDetail.payment_details
      const providerData = providerPaymentDetail.provider_data
      if (!_.isEmpty(billingInfo)) {
        setBillingData({
          email: billingInfo.contactEmail,
          brokerageName: billingInfo.brokerageName ? billingInfo.brokerageName : "",
          brokerageEmail: billingInfo.brokerageEmail ? billingInfo.brokerageEmail : "",
          firstName: billingInfo.firstName,
          lastName: billingInfo.lastName,
          phoneNumber: billingInfo.phoneNumber,
          addressLine1: billingInfo.addressLine1,
          addressLine2: billingInfo.addressLine2,
          city: billingInfo.city,
          state: billingInfo.state,
          country: billingInfo.country,
          postalCode: billingInfo.postalCode
        })
      }
      if (!_.isEmpty(productInfo)) {
        let tagsArray = [];
        let logoURL = ""
        let logoAltText = ""
        if (providerData) {
          tagsArray.push(`${providerData.display_name}`)
          logoURL = providerData.image;
          logoAltText = ""
        }
        tagsArray.push('Services')
        tagsArray.push(providerPaymentDetail.payment_frequency === 'monthly' ? 'Subscription': 'One Time')
        setProviderCardInfo({
          isLoading: false,
          id: productInfo.product_id,
          code: productInfo.code,
          title: productInfo.title,
          price: _.toNumber(productInfo.selling_price).toFixed(2),
          bannerURL: productInfo.image,
          isRecurring: productInfo.payment_frequency === 'monthly',
          logoURL,
          logoAltText,
          tagsArray,
          type:"service",
          isMobile: _.toLower(isMobile) === "true" ? true : false
        })
      }
      if (!_.isEmpty(paymentDetails)) {
        setPaymentDetails({
          cardType: paymentDetails.card_brand,
          cardEnding: paymentDetails.card_last4,
          orderId: 'XSEL-' + paymentDetails.order_number,
          transactionId: paymentDetails.stripe_invoice_number,
          purchaseDate: moment.unix(paymentDetails.purchased_on).tz('America/New_York').format('MMM DD, YYYY'),
          zeroOrder: false
        })
        setPaymentIntentInfo({
          isLoading: false,
          taxes: paymentDetails.taxes,
          total: paymentDetails.total,
          discount: 0,
          zeroOrder: false
        })
        setIsCouponApplied(false)
      }
      setBreadCrumbData([
        { name: 'Services', active: false, link: isMobile? "" : routeList.LEARN_COACHING_PAGE, isLoading: false },
        { name: 'Payment', active: false, link: isMobile? "" : routeList.LEARN_COACHING_PAGE, isLoading: false },
        { name: 'Summary', active: true, link: "", isLoading: false },
      ])
    } else {
      // if (type === 'subscription') {
      //   navigate('/subscription')
      // } else {
      //   navigate('/cart')
      // }
    }
  }, [providerPaymentDetail])

  const renderLeftPanel = () => {
    return (
      <div className="payment-info-details">
        <div className="user-payment-info">
          <div className="usermail-info">{billingData.email}</div>
          <div className="usermail-info-note">
            We’ve sent you an order invoice to this email.
          </div>
          <div className="usermail-info-brokarage">{
            billingData.brokerageName ? billingData.brokerageName : billingData.brokerageEmail
          }</div>
        </div>
        <div className="user-billing-info">
          <div className="billing-title">Billing details</div>
          <div className="billing-details">
            <div className="user-name-billing">{billingData.firstName} {billingData.lastName}</div>
            <div className="user-address-billing">
              {billingData.addressLine1} {billingData.addressLine2 ? ', ' + billingData.addressLine2 : ''},
              {billingData.city}, {billingData.state} {billingData.country} {billingData.postalCode}
            </div>
            <div className="user-country-billing">Canada</div>
            <div className="user-phone-billing">{billingData.phoneNumber}</div>
          </div>
        </div>
        <div className="user-order-info">
          <div className="order-detail-title">Order details</div>
          <div className="order-billing-details">
            {paymentDetail.zeroOrder ? "" :
            <div className="payment-method-billing">
              Payment method: <span className="text-capitalize">{paymentDetail.cardType}</span> Card ending in {paymentDetail.cardEnding}
            </div>}
            <div className="order-info-ids">
              <span className="order-billing-id">
                Order ID: {paymentDetail.orderId}
              </span>
              {type === 'subscription' &&
              <span className="order-transaction-id">
                Transaction ID: {paymentDetail.transactionId}
              </span>}
            </div>
            <div className="order-purchase-id">
              Date of purchase: {paymentDetail.purchaseDate}
            </div>
          </div>
        </div>
      </div>
    )
  }

  const renderRedirectButton = () => {
    return (
        <div className="row">
            <div className="col-12">
                <FormButtonComponent
                    btnName={`${type === 'subscription' ? 'Go to Subscription' : 'Start Learning'}`}
                    leftIcon={""}
                    btnAction={() => {
                      if (isAndroid || isIOS) {
                        try {
                          
                          if (window.callbackHandler != undefined) {
                             window.callbackHandler.postMessage(type === 'subscription' ? "click-on-go-to-subscription" :"click-on-start-learning");
                          }
                          if (window.webkit != undefined) {
                            if (
                              window.webkit.messageHandlers.callbackHandler !=
                              undefined
                            ) {
                              window.webkit.messageHandlers.callbackHandler.postMessage(
                                type === 'subscription' ? "click-on-go-to-subscription" :"click-on-start-learning"
                              );
                            }
                          }
                        } catch (err) {
                          console.log("error in sending message",err);
                        }
                      }
                      if (type === 'subscription') {
                        navigate(routeList.SUBSCRIPTION_PAGE)
                      } else {
                        navigate("/learn/courses?tab=1")
                      }
                    }}
                    isPrimary={true}
                    rightIcon={<RightArrowIcon />}
                    replaceClassName={'btn-form-comp w-100 mt-4'}
                />
            </div>
        </div>
    )
}

  return (
    <>
      <div className="row payment-b2c">
        <div className="col-12">
          <div className="col-lg-6 col-12">
            <div className="bred-icof justify-content-between">
              <BreadCrumbComponent
                crumbList={breadCrumbData}
              />
              {!isLoggedIn &&
                <div className="signin-option">
                  Have an account?{" "}
                  <button type="button" className="reset-btn"
                    onClick={() => {
                      if(isMainDomain()){
                            navigate("/verify-user")// navigate('/login')
                      }else{
                            navigate("/")
                      }
                      
                      //navigate(routeList.LOGIN_PAGE, { state: { path: '/subscription' } })
                    }}
                  >
                    <strong>Sign in</strong>
                  </button>
                </div>}
            </div>
          </div>
        </div>
      </div>
      <div className="row gx-lg-5">
        <div className="col-lg-8 col-12">
          {renderLeftPanel()}
        </div>
        <div className="col-lg-4 col-12 payment-right-box">
          <RightPanelPaymentSection
            productCardInfo={productCardInfo}
            membershipCardInfo={membershipCardInfo}
            providerCardInfo={providerCardInfo}
            paymentIntentInfo={paymentIntentInfo}
            isCouponApplied={isCouponApplied}
            showOnlyInfo={true}
            isLoggedIn={false}
            type={type}
          />
          {type === 'subscription' && renderRedirectButton()}
        </div>
      </div>
    </>
  );
};

export default PaymentB2CDetails;
